import React from 'react';
import {
    TransformComponent,
    TransformWrapper,
    type ReactZoomPanPinchProps as ZoomPanPinchProps,
} from 'react-zoom-pan-pinch';

type ZoomPanPinchWrapperProps = React.PropsWithChildren<
    ZoomPanPinchProps & {
        transform?: {
            contentClass?: string;
            contentProps?: React.HTMLAttributes<HTMLDivElement>;
            contentStyle?: React.CSSProperties;
            wrapperClass?: string;
            wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
            wrapperStyle?: React.CSSProperties;
        };
    }
>;

export default function ZoomPanPinchWrapper(props: ZoomPanPinchWrapperProps) {
    const [isPanningDisabled, setPanningDisabled] = React.useState(true);
    const onTransformed = (scale: number) => {
        const shouldDisablePanning = scale <= 1 && !isPanningDisabled;
        const shouldEnablePanning = scale > 1 && isPanningDisabled;
        if (shouldDisablePanning || shouldEnablePanning) {
            setPanningDisabled(!isPanningDisabled);
        }
    };

    return (
        <TransformWrapper
            {...props}
            centerOnInit={true}
            disablePadding={true}
            doubleClick={{ mode: 'toggle', step: 3 }}
            initialScale={1}
            limitToBounds={true}
            onTransformed={({ state }) => onTransformed(state.scale)}
            panning={{ disabled: isPanningDisabled }}
        >
            <TransformComponent {...props.transform}>{props.children}</TransformComponent>
        </TransformWrapper>
    );
}
